import React from 'react';
//import {authRoles} from '../../auth';

export const LoadLogsConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['master', 'auditor', 'rh', 'rh_not_signer', 'admin'],
    routes  : [
        {
            path     : '/loadlogs',
            component: React.lazy(() => import('./LoadLogs'))
        }
    ]
};